import { WarehouseViewComponent } from './warehouse-view/warehouse-view.component';

export const AllContainers = [
  WarehouseViewComponent
];

export * from './warehouse-view/warehouse-view.component';
